import ConfigurationTable from "components/Tables/ConfigurationTable";

import { db } from "config/firebaseConfig";
import { collection, getDocs, query } from "firebase/firestore";
import React, { useEffect, useState } from "react";
const DisciplinaryActions = () => {
  const [actions, setActions] = useState([]);
  const getData = async () => {
    let data = [];
    const q = query(collection(db, "DisciplinaryActions"));
    const result = await getDocs(q);
    result.forEach((doc) => {
      let value = doc.data();
      value.id = doc.id;
      data.push(value);
    });
    data.sort((a, b) => a.name.localeCompare(b.name));
    setActions(data);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="shadow-lg">
      <ConfigurationTable
        data={actions}
        setData={setActions}
        collectioPath={"DisciplinaryActions"}
        headerTitle="Actions"
      />
    </div>
  );
};

export default DisciplinaryActions;
